<template lang="html">
    <section class="col-md-12">
        <h2 class="ff-medium title">{{ $t("dashboardModule.myOrdersTitle") }}</h2>
        <orderList />
    </section>
</template>

<script lang="js">
import orderList from "@/components/orders/order-common/order-list";

export default  {
    components: {orderList}
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// Orders.vue?0def6889